import type { CardArtFamily } from '../../lib/cardArt';

/**
 * Clean Paper — thin schematic ink lines on cream stock.
 * Single oxblood accent for emphasis. Editorial, technical.
 */
export default function MinimalCardArt({ family }: { family: CardArtFamily }) {
  const ink = { stroke: '#0a0a0a', strokeWidth: 0.6, fill: 'none' };
  const accent = { stroke: '#8a2a2a', strokeWidth: 0.8, fill: 'none' };

  switch (family) {
    case 'tower':
      return (
        <svg viewBox="0 0 36 50" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <line x1="18" y1="4" x2="18" y2="46" {...accent} />
          <line x1="8" y1="46" x2="28" y2="46" {...ink} />
          <line x1="10" y1="46" x2="10" y2="18" {...ink} />
          <line x1="26" y1="46" x2="26" y2="18" {...ink} />
          <polyline points="10,18 18,10 26,18" {...ink} />
          <circle cx="18" cy="30" r="1.2" fill="#8a2a2a" />
        </svg>
      );
    case 'hermit':
      return (
        <svg viewBox="0 0 36 50" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <line x1="18" y1="6" x2="18" y2="44" {...ink} />
          <circle cx="18" cy="20" r="6" {...ink} />
          <circle cx="18" cy="20" r="1" fill="#8a2a2a" />
          <line x1="10" y1="44" x2="26" y2="44" {...ink} />
        </svg>
      );
    case 'star':
      return (
        <svg viewBox="0 0 36 50" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(18 22)">
            <polygon
              points="0,-10 2.5,-2.5 10,0 2.5,2.5 0,10 -2.5,2.5 -10,0 -2.5,-2.5"
              {...accent}
            />
          </g>
          <line x1="8" y1="40" x2="28" y2="40" {...ink} />
          <line x1="10" y1="44" x2="26" y2="44" {...ink} />
        </svg>
      );
    case 'wheel':
      return (
        <svg viewBox="0 0 36 50" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="18" cy="25" r="12" {...ink} />
          <circle cx="18" cy="25" r="6" {...ink} />
          <line x1="18" y1="13" x2="18" y2="37" {...ink} strokeWidth={0.4} />
          <line x1="6" y1="25" x2="30" y2="25" {...ink} strokeWidth={0.4} />
          <circle cx="18" cy="25" r="1.5" fill="#8a2a2a" />
        </svg>
      );
    case 'figure':
      return (
        <svg viewBox="0 0 36 50" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="18" cy="14" r="4" {...ink} />
          <line x1="18" y1="18" x2="18" y2="36" {...ink} />
          <line x1="18" y1="22" x2="11" y2="30" {...ink} />
          <line x1="18" y1="22" x2="25" y2="30" {...ink} />
          <line x1="18" y1="36" x2="13" y2="44" {...ink} />
          <line x1="18" y1="36" x2="23" y2="44" {...ink} />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 36 50" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="18" cy="22" r="8" {...ink} />
        </svg>
      );
  }
}
